import { HTTPService } from "../util/httpManager.js";
import { Helper } from "../util/helper.js";
import { Commands } from "../util/commandManager.js";
import { Config } from "../config/config.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import React from "react";
/*
    Ereignisse:
    onDataLoaded(field, data) -> Wenn Daten über dataSourceUrl geladen wurden
*/
export class DropDownList extends React.Component<DropDownListProps, any>{
    private dropDownListRef: any;
    private dropDownList: kendo.ui.DropDownList;
    private value: any;
    private disabled = true;
    private icuh = Helper;
    private lastDatasourceUrl: string;

    constructor(props) {
        super(props)
    }

    componentWillUnmount() {
        if (this.icuh.hasValue(this.dropDownList)) {
            //this._dropDownList.destroy();
            kendo.destroy(this.dropDownListRef);
        }
    }

    componentDidMount() {
        this.disabled = this.props.disabled || false;
        this.value = this.props.value;
        var that = this;
        const setFilter = Helper.hasValue(this.props.field.filter) && this.props.field.filter === true;
        const settings: any = {
            //value: this.props.value,
            //enable: !this._disabled,
            height: 300,
            dataSource: this.props.dataSource,
            dataTextField: this.props.field.dataTextField,
            dataValueField: this.props.field.dataValueField,
            change: (ev) => {
                this.value = ev.sender.value();
                const dataItem = ev.sender.dataItem();
                if (dataItem) {
                    that.props.onChange(that.props.field, that.icuh.getValueByPathString(dataItem, that.props.field.dataValueField), dataItem)
                }
            },
            template: this.props.field.template,
            valueTemplate: this.props.field.valueTemplate,
            filter: (setFilter) ? "contains" : null
        };
        if (this.props.field.optionLabel) {
            settings.optionLabel = this.props.field.optionLabel === Config.translations.pleaseSelect ? " " : this.props.field.optionLabel;
        }
        this.dropDownList = $(this.dropDownListRef).kendoDropDownList(settings).data("kendoDropDownList");
        // Wenn dataSourceURL verwendet wird und es einen value gibt wird bis zum Laden der richtigen Liste eine temporäre mit dem Schlüssel erzeugt
        if (!Helper.isNullOrEmpty(this.props.field.dataSourceUrl) && !Helper.isNullOrEmpty(this.value)) {
            let item = {};
            const setItem = (var1: string, var2: any) => {
                var1.split(".").forEach((value: string, index: number, array: string[]) => {
                    switch (index) {
                        case 0:
                            item[value] = array.length > 1 ? {} : var2;
                            break;
                        case 1:
                            item[array[0]][value] = array.length > 2 ? {} : var2;
                            break;
                        case 2:
                            item[array[0]][array[1]][value] = array.length > 3 ? {} : var2;
                            break;
                        case 3:
                            item[array[0]][array[1]][array[2]][value] = array.length > 4 ? {} : var2;
                            break;
                        case 4:
                            item[array[0]][array[1]][array[2]][array[3]][value] = array.length > 5 ? {} : var2;
                            break;
                    }

                });
            }
            setItem(this.props.field.dataTextField, "");
            setItem(this.props.field.dataValueField, this.value);
            this.dropDownList.setDataSource(([item]) as any);
        }
        this.dropDownList.value(this.value);

        this.dropDownList.readonly(this.disabled);
        this.dropDownList.wrapper.attr("data-readonly", this.disabled.toString());
        if (this.props.field.focus)
            this.dropDownList.focus();
        if (this.props.field.listWidth !== null && window.matchMedia(`(min-width: ${this.props.field.listWidth}px)`).matches) {
            this.dropDownList.list.width(this.props.field.listWidth);
            //https://feedback.telerik.com/kendo-jquery-ui/1579615-there-is-delay-in-expadning-when-the-dropdowntree-popup-is-opened-and-the-list-width-is-set
            this.dropDownList.list.parent().width(this.props.field.listWidth);
        }

        if (this.props.field.dataSourceUrl !== undefined && this.props.field.dataSourceUrl !== null && this.props.field.dataSourceUrl !== "") {
            let tmpUrl = this.props.field.dataSourceUrl;
            if (this.dataSourceUrlHasTemplate(tmpUrl)) {
                tmpUrl = this.processTemplate(tmpUrl);
            }
            this.loadDataFromUrl(tmpUrl);
        }

        if (this.icuh.hasValue(this.props.commandManager)) {
            this.props.commandManager.registerExecutor(this.props.field.model, (command, data) => {
                if (command === Commands.RELOADDATASOURCE) {
                    this.dropDownList.dataSource.data(this.props.dataSource);

                    if (!this.icuh.hasValue(this.value) || this.value === "" ||
                        this.isValueInData(this.props.dataSource)) {
                        this.dropDownList.value(this.value);
                    } else {
                        this.dropDownList.value(null);
                        this.dropDownList.trigger("change");
                    }
                } else if (command === Commands.RELOADVALUE) {
                    this.dropDownList.value(this.value);
                }
            });
        }
    }

    private isValueInData = (data: object[]) => {
        let validValue = false;
        for (let i = 0; i < data.length; i++) {
            let v = this.icuh.getValueByPathString(data[i], this.props.field.dataValueField);
            if (v == this.value) {
                validValue = true;
                break;
            }
        }

        return validValue;
    }

    private loadDataFromUrl = (dataSourceUrl: string) => {
        this.lastDatasourceUrl = dataSourceUrl;
        HTTPService.get(dataSourceUrl).then(data => {
            this.dropDownList.setDataSource(data);
            //wenn keine DS setzt Kendo keinen Wert -- muss wieder gesetzt werden
            if (!this.icuh.hasValue(this.value) || this.value === "" ||
                this.isValueInData(data)) {
                this.dropDownList.value(this.value);
            } else {
                this.dropDownList.value(null);
                this.dropDownList.text("");
                if (!this.props.field.readOnly && this.props.field.valueNullIfNotInDS) {
                    this.props.onChange(this.props.field, null, null)
                }
            }
            this.props.onDataLoaded(this.props.field, data);
        });
    }

    private processTemplate = (datasourceUrl: string): string => {
        try {
            if (this.dataSourceUrlHasTemplate(datasourceUrl)) {
                datasourceUrl = this.icuh.processTemplate(this.props.field.dataSourceUrl, ((match) => {
                    const result = this.props.handleEval(match);
                    if (Helper.hasValue(result)) {
                        return encodeURIComponent(result);
                    } else {
                        return "";
                    }
                }));
            }
        } catch (ex) {
            console.error("Could not process dataSourceUrl teplate. " + ex)
        }
        return datasourceUrl;
    }

    private dataSourceUrlHasTemplate = (datasourceUrl: string): boolean => {
        if (this.icuh.hasValue(this.props.field.dataSourceUrl) && this.props.field.dataSourceUrl.indexOf("{") != -1) {
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.dropDownList.readonly(this.disabled);
            this.dropDownList.wrapper.attr("data-readonly", this.disabled.toString());
        }
        if (this.value !== this.props.value) {
            this.value = this.props.value;
            this.dropDownList.value(this.value);
        }
        if (this.dataSourceUrlHasTemplate(this.props.field.dataSourceUrl)) {
            const newUrl = this.processTemplate(this.props.field.dataSourceUrl);
            if (newUrl !== this.lastDatasourceUrl) {
                this.loadDataFromUrl(newUrl);
            }
        }
        else if (Helper.hasValue(this.props.field.dataSourceUrl) && this.props.field.dataSourceUrl !== "" && this.props.field.dataSourceUrl != prevProps.field.dataSourceUrl) {
            this.loadDataFromUrl(this.props.field.dataSourceUrl);
        }

        if (this.props.field.refreshDSOnRefChange && this.props.dataSource != prevProps.dataSource) {
            this.dropDownList.dataSource.data(this.props.dataSource);
            this.dropDownList.value(this.value);
        }

    }

    render() {
        return (
            <div>
                <input
                    ref={(r) => this.dropDownListRef = r}
                    name={this.props.field.model}
                    style={{ width: "100%" }}
                    required={this.props.required}
                    data-label={this.props.field.name} />
            </div>
        );
    }
};
export interface DropDownListProps extends BaseDataSourceComponentProps {
    field: DropDownListField;
    commandManager?: CommandManagerAPI;
    handleEval?(action: string, prepare?: any);
}

export interface DropDownListField extends BaseDataSourceField {
    listWidth?: number;
    optionLabel?: string;
    template?: string;
    valueTemplate?: string;
    focus?: boolean;
    valueNullIfNotInDS?: boolean;
    filter?: boolean;
}
